<template>
  <div class="listview">
    <van-pull-refresh class="pull-refresh" v-model="refresh" @refresh="onRefresh">
      <van-list
        class="list"
        v-model="loading"
        :finished="isNoMore"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        finished-text="没有更多数据了"
        :immediate-check="isAutoLoadMore"
        @load="onLoadMore"
        :offset="100"
      >
        <slot name="item"></slot>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    },
    isRefresh: {
      type: Boolean,
      required: true,
      default: false
    },
    isLoadMore: {
      type: Boolean,
      required: true,
      default: false
    },
    isNoMore: {
      type: Boolean,
      required: false,
      default: false
    },
    isErr: {
      type: Boolean,
      required: false,
      default: false
    },
    isAutoLoadMore: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {},
  data() {
    return {
      refresh: false, //下拉刷新操作标志位，代表刷新是否进行中
      loading: false, //上拉获取更多标志位，代表加载是否进行中
      error: false
    };
  },
  watch: {
    isErr(newVal) {
      this.error = newVal;
    },
    isRefresh() {
      if (!this.isRefresh) {
        this.refresh = this.isRefresh;
      }
    },
    isLoadMore() {
      if (!this.isLoadMore) {
        this.loading = this.isLoadMore;
      }
    }
  },
  methods: {
    onRefresh() {
      // setTimeout(() => {
      //     this.$toast('刷新成功');
      //     this.isRefresh = false;
      //     this.count++;
      // }, 500);
      this.$emit("onRefresh", this.refresh);
    },
    onLoadMore() {
      // 异步更新数据
      // setTimeout(() => {
      //     for (let i = 0; i < 10; i++) {
      //     this.list.push(this.list.length + 1);
      //     }
      //     // 加载状态结束
      //     this.isLoading = false;

      //     // 数据全部加载完成
      //     if (this.list.length >= 40) {
      //     this.isFinished = true;
      //     }
      // }, 500);
      this.$emit("onLoadMore", this.loading);
    }
  }
};
</script>

<style lang="less" scoped>
.listview {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.pull-refresh {
  flex: 1;
  overflow: scroll;
}
</style>
